import angular from 'angular';

import PaymentStatusServ from '../../services/payment-status';
import CurrentCustomer from '../../models/customer';

function PaymentEnable($rootScope, PaymentStatusServ, CurrentCustomer) {
  return {
    restrict: 'A',
    link: {
      pre: function (scope, element, attrs) {
        let payment = PaymentStatusServ;
        let setClass = () => {
            payment.isExpired(attrs.paymentEnable) ?
              element.addClass('payment-disabled') :
              element.removeClass('payment-disabled');
          }
          // Customer model is updated async. Wait for it to be set.
        if (attrs.paymentEnable === 'user') {
          CurrentCustomer.subscribe(setClass);
        } else {
          setClass();
        }

        element.bind('click', function (e) {

          if (payment.isExpired(attrs.paymentEnable)) {
            e.stopImmediatePropagation();
            e.preventDefault();
            PaymentStatusServ.setExpiredMsg(attrs.paymentEnable);
            $rootScope.$apply();
          }
        });
      }
    }
  };
}
PaymentEnable.$inject = ['$rootScope', 'PaymentStatusServ', 'CurrentCustomer'];

export default angular.module('directives.payment-enable', [PaymentStatusServ])
  .directive('paymentEnable', PaymentEnable)
  .name;



// WEBPACK FOOTER //
// ./project/directives/payment-enable/index.js